import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/shared/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-view-discount',
  templateUrl: './view-discount.component.html',
  styleUrls: ['./view-discount.component.scss','../../../../../../assets/sass/pages/page-users.scss']
})
export class ViewDiscountComponent implements OnInit {
  discountId:any
  discountData:any
  imageUrl=environment.apiUrls.imageUrl;

  constructor(public apiService:ApiService,
    private activatedroute:ActivatedRoute) 
  {this.activatedroute.paramMap.subscribe(params => { 
    this.discountId = params.get('id'); 
    console.log('discountId',this.discountId)
  }); 
}

  ngOnInit(): void {this.getDiscountById()
  }
  getDiscountById(){
    this.apiService.getDiscountById(this.discountId).subscribe((res:any)=>{
      console.log('dis res=>',res)
      this.discountData=res.data
    })
  }

}
